import axios from 'axios';
import { API_BASE_URL } from '@/composable/constant';
import { AXIOS_TIMEOUT } from '@/composable/constant_common';

// Axiosのインスタンスを作成
const axiosInstance = axios.create({
  baseURL: API_BASE_URL, // APIのベースURL
  timeout: AXIOS_TIMEOUT, // タイムアウト設定（ミリ秒）
});

export default axiosInstance;
